import React from 'react';
import { useResponsive } from '@parsina/framework';
import ProfileWeb from './Profile.web.jsx';
import ProfileMobile from './Profile.mobile.jsx';

// پروفایل — two surfaces, one profile.
//
// The mobile surface is not just the desktop page in a narrow column: its four
// sections live in a scrolling `SectionNav` (a `SegmentedControl` overflows at
// 320px and takes the page into horizontal scroll), its theme picker is the kit
// `FilterChip` rather than the desktop's hand-rolled swatch buttons, and it
// carries the CLINIC SWITCHER and SIGN-OUT that the desktop keeps in the
// sidebar — which does not exist below 768px.
//
// The edit model is shared (`Profile.shared.js`), so both agree about which
// fields the form owns, what "dirty" means and which keys reach the wire.
const ProfileScreen = () => {
  const { isMobile } = useResponsive();
  return isMobile ? <ProfileMobile /> : <ProfileWeb />;
};

export default ProfileScreen;
